import { ArrowUpRight, MessageCircle } from 'lucide-react';

/**
 * Vertrauens-Sektion. Der belegte Kaufgrund laut ICP ist die persoenliche
 * Erreichbarkeit ("Deine Erreichbarkeit und Geduld"). Die Cartoon-Figur traegt
 * das im Content, der echte Dennis ab Demo.
 * Bild: frontend/public/images/cartoon-dennis.webp (mit Hintergrund, sitzt in einer
 * abgerundeten Karte, deshalb kein Freistellen noetig)
 */

export default function FounderSection() {
  return (
    <section id="ueber-uns" className="px-6 py-20 md:px-10 md:py-28 lg:px-14">
      <div
        className="mx-auto grid max-w-[1180px] items-center gap-14 rounded-[2rem] border border-[#2A1720]/10 bg-[#F8EEF2] p-7 pb-14 md:p-12 md:pb-16 lg:grid-cols-12 lg:gap-14"
        data-reveal
      >
        <div className="order-2 lg:order-1 lg:col-span-7">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.32em] text-[#F02672]">Warum es uns gibt</p>
          <h2 className="overflow-visible pb-1 text-3xl font-bold leading-[1.15] tracking-tight sm:text-4xl">
            Salon-Software hat unsere Kundinnen{' '}
            <span className="landing-gradient-text inline-block bg-gradient-to-r from-[#F05A8A] via-[#EC2B72] to-[#C83CE0] bg-clip-text pb-[0.22em] pl-[0.04em] pr-[0.16em] pt-[0.08em] italic font-light leading-[1.2] text-transparent">
              im Stich gelassen.
            </span>
          </h2>

          <div className="mt-7 space-y-4 text-base leading-relaxed text-[#5D4E55] md:text-lg">
            <p>
              Ich bin Dennis. Make It Booking ist nicht am Schreibtisch entstanden, sondern zusammen mit Ärztinnen und
              Heilpraktikerinnen aus der ästhetischen Medizin. Jedes Feature kommt aus einer echten Praxis.
            </p>
            <p>
              Deshalb machen wir das Onboarding auch selbst. Kein Chatbot, keine Ticketnummer. Du bekommst eine Person,
              die dein Setup kennt und erreichbar bleibt.
            </p>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              data-cal-link="makeit-media/mib-erstgesprach"
              data-cal-namespace="mib-erstgesprach"
              data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true","theme":"light"}'
              className="btn-shine inline-flex h-14 items-center justify-center rounded-full bg-[#171014] px-8 text-[15px] font-medium text-white shadow hover:bg-[#2A1720]"
            >
              Demo buchen, 30 Minuten
              <ArrowUpRight className="ml-2 h-4 w-4" />
            </button>
            <span className="inline-flex items-center gap-2 text-sm text-[#7B6A72]">
              <MessageCircle className="h-4 w-4 text-[#D72D6B]" />
              Antwort in der Regel am selben Tag
            </span>
          </div>
        </div>

        <div className="order-1 lg:order-2 lg:col-span-5">
          <div className="relative mx-auto w-full max-w-[380px]">
            <div className="overflow-hidden rounded-[2rem] border border-white/60 shadow-[0_30px_80px_-40px_rgba(42,23,32,0.5)]">
              <img
                src="/images/cartoon-dennis.webp"
                alt="Dennis, Gründer von Make It Booking"
                className="block aspect-[4/5] w-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2.5 whitespace-nowrap rounded-2xl border border-[#2A1720]/10 bg-white px-4 py-3 shadow-lg">
              <span className="flex h-2 w-2 shrink-0">
                <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-[#F05A8A] opacity-70" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#EC2B72]" />
              </span>
              <span className="text-sm font-medium text-[#171014]">Dennis, Gründer</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
